import { storeToRefs } from 'pinia'

import { useDraftStore } from '~/stores/draft'
import { useInfluencersDuplicatesStore } from '~/stores/influencersDuplicates'
import { useInfluencersRecommendationsStore } from '~/stores/influencersRecommendations'
import { useMiscDraftStore } from '~/stores/miscDraft'

import type { Influencer, StatsV3Influencer } from '~/types/influencer'

export function useCartToggleInfluencer() {
  const { $pinia } = useNuxtApp()
  const route = useRoute()
  const { ADD_INF, REMOVE_INF } = useDraftStore($pinia)
  const { SET_MISMATCH_MODAL } = useMiscDraftStore($pinia)

  const { mismatches: MISMATCHES } = storeToRefs(
    useInfluencersRecommendationsStore($pinia),
  )
  const { list: DUPLICATE_SUBMISSIONS } = storeToRefs(
    useInfluencersDuplicatesStore($pinia),
  )
  const { INFLUENCERS: CART } = storeToRefs(useDraftStore($pinia))

  function toggleInf(influencer: StatsV3Influencer | Influencer) {
    const { path, query } = route
    const isInDraft = path.includes('/draft') || query?.draftId
    const allowedMismatchTypes = isInDraft
      ? ['country', 'duplicate', 'lyrics_lang', 'track_age']
      : ['country']
    const isSelected = CART.value.includes(influencer.id)
    const influencerId = influencer.id

    if (isSelected) {
      REMOVE_INF(influencerId)
    } else if (
      (MISMATCHES.value?.[influencerId] &&
        MISMATCHES.value?.[influencerId].some(({ type }) =>
          allowedMismatchTypes.includes(type),
        )) ||
      DUPLICATE_SUBMISSIONS.value.includes(influencerId)
    ) {
      SET_MISMATCH_MODAL({
        influencer,
        isDisplayed: true,
      })
    } else {
      ADD_INF(influencerId)
    }
  }

  return {
    toggleInf,
  }
}
